import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AppContextProvider } from '@v2/contexts';
import { SettingsShell } from '@v2/layouts';
import AccountsPage from '@v2/pages/accounts';
import PartnersPage from '@v2/pages/partners';
import PimsPage from '@v2/pages/pims';
import BitwerxOfferingsPage from '@v2/pages/bitwerxOfferings';
import MissionControlManagerPage from '@v2/pages/missionControlManager';
import BulkManifestUpdatePage from '@v2/pages/bulkManifestUpdate';
import { settingsCategories } from './routes';
import { styles } from './styles';

const BASE_PATH = '/settings';

export interface SettingsPageProps {
  userName: string;
  userRole: string;
  updateCount: number;
  onLogout: () => void;
  onOpenUpdateLog: () => void;
}

const SettingsPage: React.FC<SettingsPageProps> = ({
  userName,
  userRole,
  updateCount,
  onLogout,
  onOpenUpdateLog,
}) => {
  return (
    <AppContextProvider>
      <div className={styles.root}>
        <SettingsShell
          userName={userName}
          userRole={userRole}
          updateCount={updateCount}
          categories={settingsCategories}
          basePath={BASE_PATH}
          onLogout={onLogout}
          onOpenUpdateLog={onOpenUpdateLog}>
          <Switch>
            <Route path={`${BASE_PATH}/accounts`} component={AccountsPage} />
            <Route path={`${BASE_PATH}/partners`} component={PartnersPage} />
            <Route path={`${BASE_PATH}/pims`} component={PimsPage} />
            <Route path={`${BASE_PATH}/offerings`} component={BitwerxOfferingsPage} />
            <Route path={`${BASE_PATH}/mission-control`} component={MissionControlManagerPage} />
            <Route path={`${BASE_PATH}/bulk-manifest`} component={BulkManifestUpdatePage} />
            <Route exact path={BASE_PATH}>
              <Redirect to={`${BASE_PATH}/accounts`} />
            </Route>
          </Switch>
        </SettingsShell>
      </div>
    </AppContextProvider>
  );
};

export default SettingsPage;
